import * as XLSX from "xlsx";
import { Dimension } from "../../types/types";
import axios from "axios";

//Code added for creation of excel file and push same on Azure server
interface IQuestionAnswer {
  [key: string]: any;
}

const generateExcel = async ({
  updatedDimensions,
}: {
  updatedDimensions: Dimension[];
}) => {
  const userEmail = localStorage.getItem("userEmail");
  try {
    if (updatedDimensions) {
      // Restructure the data into an array of objects
      const formattedData = updatedDimensions.map(
        (response: {
          questions: any[];
          ID: any;
          Level: any;
          LevelId: any;
          MaxScore: any;
          Name: any;
          Narrative: any;
          Percentage: any;
        }) => {
          const questions = response.questions.map((question) => ({
            ID: question.ID,
            QuestionText: question.QuestionText,
            Weight: question.Weight,
            Max: question.Max,
            Answer: question.Answer ? question.Answer.QuestionAnswerText : "", // Assuming Answer is an object
          }));
          return {
            ID: response.ID,
            Level: response.Level,
            LevelId: response.LevelId,
            MaxScore: response.MaxScore,
            Name: response.Name,
            Narrative: response.Narrative,
            Percentage: response.Percentage,
            ...questions.reduce((acc: IQuestionAnswer, question, index) => {
              acc[`Question${index + 1}`] = question.QuestionText;
              acc[`Answer${index + 1}`] = question.Answer;
              return acc;
            }, {}),
          };
        }
      );
      const ws = XLSX.utils.json_to_sheet(formattedData);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Responses");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
      const excelBlob = new Blob([s2ab(wbout)], {
        type: "application/octet-stream",
      });
      function s2ab(s: any) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
      //check userEmail is null or not if not then file name should be userEmail_response.xlsx else response.xlsx
      const excelName = userEmail
        ? `${userEmail}_responses.xlsx`
        : "response.xlsx";

      const formData = new FormData();
      formData.append("file", excelBlob, excelName);
      const config = { headers: { "Content-Type": "multipart/form-data" } };

        // Use axios.post with FormData
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/uploadFile`,
          formData,
          config
        );

        if(response.status ===200)
          console.log("Uploaded excel file on azure: ")
        else {
          console.log("Error occured while uploading excel file: ", response?.statusText)
        }

    }
  } catch (error) {
    console.error("Error uploading file on Azure:", error);
  }
};

export default generateExcel;
